import { Spin } from 'antd';
import styled from 'styled-components';
import '@src/styles/components/loading.scss';
import {useSelector} from "react-redux";

const CustomSpin = styled(Spin)`
  position: fixed !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 100vh !important;
  max-height: unset !important;
  z-index: 9999999 !important;
  width: 100%;
`;

const LoadingContent = styled.div`
  min-width: 250px;
  height: auto;
  padding: 30px 10px;
  border-radius: 7px;
  box-shadow: 0 0 1px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04);
  background-color: #fff;
  position: unset !important;
    .loading-text {
        font-size: 12px;
        word-break: break-all;
    }
`;

const LoadingGift = () => {
  return (
    <div className="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

const LoadingImage = () => {
  return <CustomSpin indicator={<LoadingGift />} />;
};

const Loading = (props) => {
  const { spinText } = useSelector((state) => state?.appSettings);
  return (
    <CustomSpin
      {...props}
      wrapperClassName={'edenred-loading'}
      indicator={
        <LoadingContent>
          <LoadingGift />
          <div className="loading-text" dangerouslySetInnerHTML={{__html: spinText}} />
        </LoadingContent>
      }
    />
  );
};

export { Loading, LoadingImage };
